import { render, staticRenderFns } from "./ApprovalRequestLine.vue?vue&type=template&id=56f9cb73"
import script from "./ApprovalRequestLine.vue?vue&type=script&lang=js"
export * from "./ApprovalRequestLine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports